module.exports = __webpack_public_path__ + "img/othbg.8d196af5.jpg";